import { APIClient } from "./axiosClient";
import { ApiResponse, IPaginatedResponse } from "./types/_base";
import { ICategory, ICategoryPayload, ICategoryQuery, IOrderCategoryPayload, IUpdateStatusCategoryPayload } from "./types/_category";

const api = new APIClient();

const path = "/fields";
const categoryApi = {
  getCategories(
    params?: ICategoryQuery
  ): Promise<ApiResponse<IPaginatedResponse<ICategory>>> {
    const url = `${path}`;
    return api.get(url, params) as unknown as Promise<ApiResponse<IPaginatedResponse<ICategory>>>;
  },
  updateStatus(id: number,params: IUpdateStatusCategoryPayload): Promise<ApiResponse<ICategory>> {
    const url = `${path}/${id}`;
    return api.put(url, { is_active: params.is_active }) as unknown as Promise<ApiResponse<ICategory>>;
  },
  createCategory(params: ICategoryPayload): Promise<ApiResponse<ICategory>> {
    const url = `${path}`;
    return api.post(url, params) as unknown as Promise<ApiResponse<ICategory>>;
  },
  updateCategory(id: number,params: ICategoryPayload): Promise<ApiResponse<ICategory>> {
    const url = `${path}/${id}`;
    return api.put(url, params) as unknown as Promise<ApiResponse<ICategory>>;
  },
  deleteCategory(id: number): Promise<ApiResponse<ICategory>> {
    const url = `${path}/${id}`;
    return api.delete(url) as unknown as Promise<ApiResponse<ICategory>>;
  },
  orderCategory(params: IOrderCategoryPayload[]): Promise<ApiResponse<ICategory>> {
    const url = `${path}/reorder`;
    return api.post(url, params) as unknown as Promise<ApiResponse<ICategory>>;
  },
};

export default categoryApi;
